import { useState, useEffect } from 'react';
import ComponentNotifier from '../services/wss/ComponentNotifier';
import bodyEditorEngine from './Core/BodyEditorEngine';

const _name = 'BodyEditorEngine';

/**
 * useBodyEditor — subscribes to BodyEditorEngine state.
 * @returns {{ isOpen: boolean, entry: object|null }}
 */
export default function useBodyEditor() {
    const [state, setState] = useState({
        isOpen: bodyEditorEngine.isOpen(),
        entry: bodyEditorEngine.getEntry(),
    });

    useEffect(() => {
        const unsub = ComponentNotifier.subscribe(_name, (e) => {
            setState({ isOpen: e.data.isOpen, entry: e.data.entry });
        });
        return () => unsub?.();
    }, []);

    return state;
}
